import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {AdaptDockedPanelModule, AdaptNavigationModule, AdaptNotFoundModule, AdaptRxTypeaheadModule, AdaptToastModule} from '@bmc-ux/adapt-angular';
import {SharedModule} from './shared-module/shared.module';
import {AuthRoutingModule} from './auth-routing.module';
import {SearchComponent} from './search/search.component';
import {SearchResultComponent} from './search/search-result/search-result.component';
import {RecentlyViewedProductsComponent} from './search/recently-viewed-products/recently-viewed-products.component';
import {AppRoutingModule} from './app-routing.module';
import {ProductListComponent} from './search/product-list/product-list.component';

@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    SearchResultComponent,
    RecentlyViewedProductsComponent,
    ProductListComponent
   ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthRoutingModule,
    SharedModule,
    AdaptNotFoundModule,
    AdaptNavigationModule.forRoot(),
    AdaptDockedPanelModule.forRoot(),
    AdaptToastModule,
    AdaptRxTypeaheadModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
